@if (
  ownRole() !== 'READER' &&
  rowIsOwner() &&
  (!allowOwner() || ownRole() !== 'OWNER' || numberOfOwners() === 1)
) {
  <section>Owner</section>
} @else if (
  canManageRow() &&
  ((ownRole() !== 'READER' && (!rowIsOwner() || ownRole() === 'OWNER')) || isOwnRow())
) {
  <section>
    <mat-select
      class="role-selector"
      [value]="row().role"
      (selectionChange)="onUpdateShare($event.value)"
    >
      @if (allowOwner()) {
        <mat-option [value]="'OWNER'" [disabled]="!canSelectRole('OWNER')"> Owner</mat-option>
      }
      @if (!hideDeviceManager()) {
        @if (canShowUpgradeAction('DEVICE_MANAGER')) {
          <mat-option [value]="'DEVICE_MANAGER'" class="upgrade-option" [disabled]="true">
            <span class="upgrade-option-content">
              <span>Device Manager</span>
              <span class="upgrade-action-row">
                @if (hasPendingRequest('DEVICE_MANAGER')) {
                  <span class="upgrade-requested-text">Requested </span> |
                  <button
                    type="button"
                    class="upgrade-request-btn"
                    (click)="onWithdrawRequestedShare('DEVICE_MANAGER'); $event.stopPropagation()"
                  >
                    Withdraw
                  </button>
                } @else {
                  <button
                    type="button"
                    class="upgrade-request-btn"
                    (click)="onRequestHigherRole('DEVICE_MANAGER'); $event.stopPropagation()"
                  >
                    Request Upgrade
                  </button>
                }
              </span>
            </span>
          </mat-option>
        } @else {
          <mat-option [value]="'DEVICE_MANAGER'" [disabled]="!canSelectRole('DEVICE_MANAGER')">
            Device Manager
          </mat-option>
        }
      }
      @if (canShowUpgradeAction('DATA_MANAGER')) {
        <mat-option [value]="'DATA_MANAGER'" class="upgrade-option" [disabled]="true">
          <span class="upgrade-option-content">
            <span>Data Manager</span>
            <span class="upgrade-action-row">
              @if (hasPendingRequest('DATA_MANAGER')) {
                <span class="upgrade-requested-text">Requested</span> |
                <button
                  type="button"
                  class="upgrade-request-btn"
                  (click)="onWithdrawRequestedShare('DATA_MANAGER'); $event.stopPropagation()"
                >
                  Withdraw
                </button>
              } @else {
                <button
                  type="button"
                  class="upgrade-request-btn"
                  (click)="onRequestHigherRole('DATA_MANAGER'); $event.stopPropagation()"
                >
                  Request Upgrade
                </button>
              }
            </span>
          </span>
        </mat-option>
      } @else {
        <mat-option [value]="'DATA_MANAGER'" [disabled]="!canSelectRole('DATA_MANAGER')">
          Data Manager</mat-option
        >
      }
      <mat-option [value]="'READER'" [disabled]="!canSelectRole('READER')"> Reader</mat-option>
    </mat-select>
  </section>
} @else {
  {{ transformedRole() }}
}
